import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

// Importaciones de entornos.
import { environment } from '../../environments/environment';

/**
 * Servicio encargado de gestionar los roles de usuario en la aplicación.
 *
 * Este servicio incluye funcionalidades como la asignación de roles a usuarios, la verificación de
 * permisos asociados a los roles, y la obtención de la lista de roles disponibles en la aplicación.
 *
 * `@Injectable` permite la inyección de este servicio en otros componentes o servicios.
 * `providedIn: 'root'` garantiza que el servicio esté disponible en toda la aplicación como un singleton,
 * lo que significa que solo habrá una instancia de este servicio en toda la app.
 */
@Injectable({
  providedIn: 'root',
})
export class RoleService {
  /**
   * URL base para las solicitudes relacionadas con los roles.
   * Se utiliza para realizar operaciones como obtener roles a través de la API.
   */
  private url: string = '/roles';

  /**
   * Constructor del servicio que inyecta `HttpClient` para realizar solicitudes HTTP a la API.
   *
   * @param http Cliente HTTP de Angular para gestionar peticiones y respuestas del servidor.
   */
  constructor(private http: HttpClient) {}

  /**
   * Método para obtener todos los roles desde la API.
   * Realiza una solicitud HTTP para recuperar los datos y los devuelve en formato de promesa.
   *
   * @returns Una promesa que se resuelve con los datos obtenidos de la API.
   */
  public getAll(): Promise<any> {
    return firstValueFrom(this.http.get(environment.apiUrl + this.url));
  }
}
